export const convertArrayToObject = (data, key = '_id') =>
  data.reduce((newObject, el) => {
    newObject[el[key]] = el;
    return newObject;
  }, {});
